export * from './physiciansQueries';
export { physicianShape } from './physiciansShapes';
export {
  getPhysician,
  getPracticePhysicians,
  getPracticePhysiciansById,
} from './physiciansSelectors';
export { physicianSchema } from './physiciansSchemas';
export * from './physiciansHooks';
